/**
 * The agenda editor's bounds, mirroring the backend agenda validator
 * (`MeetingAgendaUpdateRequestValidator`, reused by its thematic-meeting counterpart). Both flows
 * that edit an agenda — the post-review meeting of a cycle and a thematic meeting — share the same
 * endpoints and therefore the same limits, so they live here once instead of in each editor.
 *
 * Enforced client-side so an overflow stops at the control the manager is using, instead of coming
 * back as a validation error the editor can only surface as a generic toast.
 */
export const AGENDA_MAX_ITEMS = 20;

/** The duration a topic starts with, when nothing else sets it. */
export const AGENDA_DEFAULT_TOPIC_DURATION_MINUTES = 5;

/** The longest topic, in a meeting's agenda as in a meeting plan template. */
export const AGENDA_ITEM_MAX_DURATION_MINUTES = 480;

export const AGENDA_MAX_DISCUSSION_POINTS_PER_ITEM = 10;

export const AGENDA_ITEM_TITLE_MAX_LENGTH = 200;

export const AGENDA_DISCUSSION_POINT_TITLE_MAX_LENGTH = 500;

export const AGENDA_CONTEXT_MAX_LENGTH = 2000;

export const AGENDA_RESPONSE_MAX_LENGTH = 5000;

export const AGENDA_OPENING_STATEMENT_MAX_LENGTH = 2000;
